import { Link } from "react-router-dom";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const SERVICES = [
  { to: "/executive-coaching", label: "Executive Coaching" },
  { to: "/business-development", label: "Business Development" },
  { to: "/speaking", label: "Motivational Speaking" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-obsidian text-ivory">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 pt-24 pb-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 pb-16 border-b border-white/10">
          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold mb-6">
              Genesis Consulting Firm
            </p>
            <p className="font-serif text-4xl sm:text-5xl leading-tight max-w-xl">
              The Beginning of <span className="italic text-gold">What's Next.</span>
            </p>
          </div>
          <Link
            to="/consultation"
            data-testid="footer-cta-book-consultation"
            className="inline-block shrink-0 border border-gold/60 text-gold px-8 py-4 font-mono text-[11px] tracking-[0.25em] uppercase hover:bg-gold hover:text-obsidian transition-colors duration-300"
          >
            Book a Consultation
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 py-14">
          <div className="col-span-2 md:col-span-1">
            <p className="font-serif text-2xl">Genesis</p>
            <p className="font-mono text-[9px] tracking-[0.35em] uppercase text-gold mt-1 mb-5">
              Consulting Firm
            </p>
            <p className="text-sm text-ivory/50 font-light leading-relaxed max-w-xs">
              Executive coaching, business development, and motivational speaking for
              those ready to move forward with clarity and intention.
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ivory/40 mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase()}`} className="text-sm text-ivory/70 hover:text-gold transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/consultation" data-testid="footer-nav-consultation" className="text-sm text-ivory/70 hover:text-gold transition-colors">
                  Book a Consultation
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ivory/40 mb-5">Services</p>
            <ul className="space-y-3">
              {SERVICES.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-service-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-ivory/70 hover:text-gold transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ivory/40 mb-5">Connect</p>
            <a href="mailto:info@genesisconsultinghq.com" data-testid="footer-email-link" className="text-sm text-ivory/70 hover:text-gold transition-colors block mb-3">
              info@genesisconsultinghq.com
            </a>
            <p className="text-sm text-ivory/50 font-light">Inspiration + Clarity + Strategy + Action</p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-ivory/35">
            © 2026 Genesis Consulting Firm
          </p>
        </div>
      </div>
    </footer>
  );
}
